import { z } from "zod";
import { TaskEventAttemptReason, TaskEventAttemptReasonSchema } from "@remi/enums/task-event/attempt-reason";
import { TaskType } from "@remi/enums/task-type";

const ReviewWorkOrderRejectionDecisionSchema = z.object({
  requestTaskEventId: z.string(),
  request: TaskEventAttemptReasonSchema.extract([
    TaskEventAttemptReason.WORK_ORDER_TRAVEL_ADDER_REQUESTED,
    TaskEventAttemptReason.WORK_ORDER_JOB_SIZE_ADDER_REQUESTED,
    TaskEventAttemptReason.WORK_ORDER_SCOPE_INCORRECT,
  ]),
  requestedAt: z.coerce.date(),
  requestedByName: z.string().nullable(),
  contractorNote: z.string().nullable(),
  decision: z.enum(["APPROVED", "REJECTED_AND_REASSIGNED", "SCOPE_UPDATED"]),
  approvedAmountCents: z.number().int().nullable(),
  opsNote: z.string().nullable(),
  requestedReassignToOrganizationId: z.string().nullish(),
  requestedReassignToOrganizationName: z.string().nullish(),
});

export const ReviewWorkOrderRejectionTaskAttemptSchema = z.object({
  type: z.literal(TaskType.REVIEW_WORK_ORDER_REJECTION),
  // Optional: completions before decisions were recorded wrote a bare `{ type }` row for this task.
  decided: ReviewWorkOrderRejectionDecisionSchema.optional(),
});

export type ReviewWorkOrderRejectionTaskAttempt = z.infer<typeof ReviewWorkOrderRejectionTaskAttemptSchema>;
